<div id="custom-header" class="header-strip mobile-fix-header" *ngIf="isMobile !== '1'">
  <div>
    <div class="col logo1 col-xs-11 col-md-11">
      <img id="bfdl-Logo-light1" class="pad-t-2" src="assets/img/dark/logo.png" alt="logo" width="88">
      <img id="bfl-Logo-light1" class="cursor-pointer" (click)="navigateToBFLPage()" src="assets/img/svg/Bajaj Finserv Digital_Logo_Reverse.png" loading="lazy" width="80">
    </div>
  </div>


  <div class="col logo1 col-xs-11 col-md-11 page-heading-txt pad-l0" [ngClass]="bflJourney ? 'align-spc':''">
    <div class="insurance-head">Health Insurance</div>
  </div>
  <app-toggle-switch [showToggle]="!bflJourney" class="pull-right toggle-spc"></app-toggle-switch>
</div>